import type from "../commons/patientActionStatus";

const DEFAULT_STATE = {
  patientInfo: null,
  error: null,
  requestState: false,
  status: null,
  vitals: [],
  consultations: [],
  vitalsRange: {},
  leapScore: {},
  history: {},
  vitalsCreated: {},
  tests: [],
  testCreated: {},
  lifestyleGraphs: null,
  dietPlan: [],
  recommendedLifestyle: null,
  recommendedLifestyleUpdateStatus: null,
  stressChart: null,
  physicalFitness: null,
  weightGainChart: null,
  visitsChart: null,
  ongoingComplaints: [],
  endedComplaints: [],
  ongoingRisks: [],
  endedRisks: [],
  complaintCreated: {},
  riskCreated: {},
  complaintUpdated: {},
  riskUpdated: {},
  weightCreated: {},
  prescriptionChart: null,
  dfmrChart: null,
  emotionData: null,
  conditionCreated: null,
  complaintsWithCondition:[],
  conditionTimeline:null
};

export const patientReducer = (state = DEFAULT_STATE, action) => {
  const actionType = action.type;
  let patientInfo;
  let vitals;
  let consultations;
  let vitalsRange;
  let leapScore;
  let history;
  let vitalsCreated;
  let testCreated;
  let tests;
  let lifestyleGraphs;
  let dietPlan;
  let recommendedLifestyle;
  let recommendedLifestyleUpdateStatus;
  let stressChart;
  let physicalFitness;
  let weightGainChart;
  let visitsChart;
  let complaintCreated;
  let riskCreated;
  let complaintUpdated;
  let riskUpdated;
  let error = action.error;
  let requestState = action.requestState;
  let status = action.status;
  let prescriptionChart;
  let dfmrChart;
  let emotionData;
  let conditionData;
  let complaintCondition;
  let timeline;
  switch (actionType) {
    case type.GET_PATIENT_DETAILS_REQUEST:
      return { ...state, patientInfo: action.payload?.isSilent ? state.patientInfo : null, requestState, status };

    case type.GET_PATIENT_DETAILS_SUCCESS:
      patientInfo = action.result;
      return {
        ...state,
        patientInfo,
        requestState,
        status,
      };

    case type.GET_PATIENT_DETAILS_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_PATIENT_VITALS_REQUEST:
      return { ...state, vitals: [], requestState, status };

    case type.GET_PATIENT_VITALS_SUCCESS:
      vitals = action.result;
      return {
        ...state,
        vitals,
        requestState,
        status,
      };

    case type.GET_PATIENT_VITALS_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_PATIENT_CONSULTATION_REQUEST:
      return { ...state, consultations: {}, requestState, status: null };

    case type.GET_PATIENT_CONSULTATION_SUCCESS:
      consultations = action.result;
      return {
        ...state,
        consultations,
        requestState,
        status,
      };

    case type.GET_PATIENT_CONSULTATION_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_PATIENT_VITALS_RANGE_REQUEST:
      return { ...state, vitalsRange: {}, requestState, status };

    case type.GET_PATIENT_VITALS_RANGE_SUCCESS:
      vitalsRange = action.result;
      return {
        ...state,
        vitalsRange,
        requestState,
        status,
      };

    case type.GET_PATIENT_VITALS_RANGE_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_PATIENT_LEAP_SCORE_REQUEST:
      return { ...state, leapScore: {}, requestState, status };

    case type.GET_PATIENT_LEAP_SCORE_SUCCESS:
      leapScore = action.result;
      return {
        ...state,
        leapScore,
        requestState,
        status,
      };

    case type.GET_PATIENT_LEAP_SCORE_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_PATIENT_HISTORY_REQUEST:
      return { ...state, history: {}, requestState, status: null };

    case type.GET_PATIENT_HISTORY_SUCCESS:
      history = action.result;
      return {
        ...state,
        history,
        requestState,
        status,
      };

    case type.GET_PATIENT_HISTORY_FAILURE:
      return { ...state, error, requestState, status };

    case type.CREATE_PATIENT_HISTORY_REQUEST:
      return { ...state, history: {}, requestState, status };

    case type.CREATE_PATIENT_HISTORY_SUCCESS:
      history = action.result;
      return {
        ...state,
        history,
        requestState,
        status,
      };

    case type.CREATE_PATIENT_HISTORY_FAILURE:
      return { ...state, error, requestState, status };

    case type.UPDATE_PATIENT_HISTORY_REQUEST:
      return { ...state, history: {}, requestState, status };

    case type.UPDATE_PATIENT_HISTORY_SUCCESS:
      history = action.result;
      return {
        ...state,
        history,
        requestState,
        status,
      };

    case type.UPDATE_PATIENT_HISTORY_FAILURE:
      return { ...state, error, requestState, status };

    case type.CREATE_VITALS_REQUEST:
      return { ...state, vitalsCreated: {}, requestState, status };

    case type.CREATE_VITALS_SUCCESS:
      vitalsCreated = action.result;
      return {
        ...state,
        vitalsCreated,
        requestState,
        status,
      };

    case type.CREATE_VITALS_FAILURE:
      return { ...state, error, requestState, status };

    case type.RESET_VITALS_CREATION_STATE:
      return {
        ...state,
        vitalsCreated: {},
      };

    case type.GET_PATIENT_TESTS_REQUEST:
      return { ...state, tests: [], requestState, status };

    case type.GET_PATIENT_TESTS_SUCCESS:
      tests = action.result;
      return {
        ...state,
        tests,
        requestState,
        status,
      };

    case type.GET_PATIENT_TESTS_FAILURE:
      return { ...state, error, requestState, status };

    case type.SUBMIT_PATIENT_TESTS_REQUEST:
      return { ...state, testCreated: {}, requestState, status };

    case type.SUBMIT_PATIENT_TESTS_SUCCESS:
      testCreated = action.result;
      return {
        ...state,
        testCreated,
        requestState,
        status,
      };

    case type.SUBMIT_PATIENT_TESTS_FAILURE:
      return { ...state, error, requestState, status };

    case type.RESET_TEST_CREATION_STATE:
      return {
        ...state,
        testCreated: {},
      };

    case type.GET_LIFESTYLE_CHARTS_REQUEST:
      return { ...state, lifestyleGraphs: null, requestState, error, status };

    case type.GET_LIFESTYLE_CHARTS_SUCCESS:
      lifestyleGraphs = action.result;
      return {
        ...state,
        lifestyleGraphs,
        requestState,
        status,
      };

    case type.GET_LIFESTYLE_CHARTS_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_RECOMMENDED_DIET_PLAN_REQUEST:
      return { ...state, dietPlan: [], requestState, error, status };

    case type.GET_RECOMMENDED_DIET_PLAN_SUCCESS:
      dietPlan = action.result;
      return {
        ...state,
        dietPlan,
        requestState,
        status,
      };

    case type.GET_RECOMMENDED_DIET_PLAN_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_RECOMMENDED_LIFESTYLE_REQUEST:
      return { ...state, requestState, recommendedLifestyle: null, error, status };

    case type.GET_RECOMMENDED_LIFESTYLE_SUCCESS:
      recommendedLifestyle = action.result;
      return {
        ...state,
        recommendedLifestyle,
        requestState,
        status,
        recommendedLifestyleUpdateStatus: "IDLE",
      };

    case type.GET_RECOMMENDED_LIFESTYLE_FAILURE:
      return { ...state, error, requestState, status };

    case type.CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_REQUEST:
      return {
        ...state,
        requestState,
        status,
        recommendedLifestyleUpdateStatus: "UPDATING",
      };

    case type.CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_SUCCESS:
      return {
        ...state,
        requestState,
        status,
        recommendedLifestyleUpdateStatus: "SUCCESS",
      };

    case type.CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_FAILURE:
      return {
        ...state,
        error,
        requestState,
        status,
        recommendedLifestyleUpdateStatus: "FAILURE",
      };

    case type.GET_EMOTION_CHARTS_REQUEST:
      return { ...state, stressChart: null, requestState, error, status };

    case type.GET_EMOTION_CHARTS_SUCCESS:
      stressChart = action.result;
      return {
        ...state,
        stressChart,
        requestState,
        status,
      };

    case type.GET_EMOTION_CHARTS_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_PHYSICAL_FITNESS_REQUEST:
      return { ...state, physicalFitness: null, requestState, error, status };

    case type.GET_PHYSICAL_FITNESS_SUCCESS:
      physicalFitness = action.result;
      return {
        ...state,
        physicalFitness,
        requestState,
        status,
      };

    case type.GET_PHYSICAL_FITNESS_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_WEIGHT_GAIN_CHART_REQUEST:
      return { ...state, weightGainChart: null, requestState, error, status };

    case type.GET_WEIGHT_GAIN_CHART_SUCCESS:
      weightGainChart = action.result;
      return {
        ...state,
        weightGainChart,
        requestState,
        status,
      };

    case type.GET_WEIGHT_GAIN_CHART_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_VISITS_CHARTS_REQUEST:
      return { ...state, visitsChart: null, requestState, error, status };

    case type.GET_VISITS_CHARTS_SUCCESS:
      visitsChart = action.result;
      return {
        ...state,
        visitsChart,
        requestState,
        status,
      };

    case type.GET_VISITS_CHARTS_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_PATIENT_COMPLAINTS_REQUEST:
      return { ...state, ongoingComplaints: [], requestState, error, status, };

    case type.GET_PATIENT_ENDED_COMPLAINTS_REQUEST:
      return { ...state, endedComplaints: [], requestState, error, status, };

    case type.GET_PATIENT_COMPLAINTS_SUCCESS:
      if (action.dataType == "ONGOING") {
        return {
          ...state,
          ongoingComplaints: action.result,
          requestState,
          status,
        };
      }
      else {
        return {
          ...state,
          endedComplaints: action.result,
          requestState,
          status,
        };
      }

    case type.GET_PATIENT_COMPLAINTS_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_PATIENT_RISKS_REQUEST:
      return { ...state, ongoingRisks: state.ongoingRisks, requestState, error, status, };
      
    case type.GET_PATIENT_ASSESS_RISKS_REQUEST:
      return { ...state, ongoingRisks: state.ongoingRisks, requestState, error, status, };

    case type.GET_PATIENT_ENDED_RISKS_REQUEST:
      return { ...state, endedRisks: state.endedRisks, requestState, error, status, };

    case type.GET_PATIENT_RISKS_SUCCESS:
      if (action.dataType == "ONGOING") {
        return {
          ...state,
          ongoingRisks: action.result,
          requestState,
          status,
        };
      }
      else {
        return {
          ...state,
          endedRisks: action.result,
          requestState,
          status,
        };
      }

    case type.GET_PATIENT_RISKS_FAILURE:
      return { ...state, error, requestState, status };

    case type.CREATE_COMPLAINT_REQUEST:
      return { ...state, complaintCreated: {}, requestState, status };

    case type.CREATE_COMPLAINT_SUCCESS:
      complaintCreated = action.result;
      return {
        ...state,
        complaintCreated,
        requestState,
        status,
      };

    case type.CREATE_COMPLAINT_FAILURE:
      return { ...state, error, requestState, status };

    case type.CREATE_RISK_REQUEST:
      return { ...state, riskCreated: {}, requestState, status };

    case type.CREATE_RISK_SUCCESS:
      riskCreated = action.result;
      return {
        ...state,
        riskCreated,
        requestState,
        status,
      };

    case type.CREATE_RISK_FAILURE:
      return { ...state, error, requestState, status };


    case type.UPDATE_COMPLAINT_REQUEST:
      return { ...state, complaintUpdated: {}, requestState, status };

    case type.UPDATE_COMPLAINT_SUCCESS:
      complaintUpdated = action.result;
      return {
        ...state,
        complaintUpdated,
        requestState,
        status,
      };

    case type.UPDATE_COMPLAINT_FAILURE:
      return { ...state, error, requestState, status };

    case type.UPDATE_RISK_REQUESTT:
      return { ...state, riskUpdated: {}, requestState, status };

    case type.UPDATE_RISK_SUCCESS:
      riskUpdated = action.result;
      return {
        ...state,
        riskUpdated,
        requestState,
        status,
      };

    case type.UPDATE_RISK_FAILURE:
      return { ...state, error, requestState, status };

    case type.UPDATE_PATIENT_DETAILS_REQUEST:
      return { ...state, requestState, status };

    case type.UPDATE_PATIENT_DETAILS_SUCCESS:
      patientInfo = { ...state.patientInfo, ...action.result };
      return {
        ...state,
        patientInfo,
        requestState,
        status,
      };

    case type.UPDATE_PATIENT_DETAILS_FAILURE:
      return { ...state, error, requestState, status };

    case type.ADD_WEIGHT_GAIN_CHART_DATA_REQUEST:
      return { ...state, weightCreated: {}, requestState, error, status };

    case type.ADD_WEIGHT_GAIN_CHART_DATA_SUCCESS:
      return {
        ...state,
        weightCreated: action.result,
        requestState,
        status,
      };

    case type.ADD_WEIGHT_GAIN_CHART_DATA_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_PRESCRIPTION_CHART_REQUEST:
      return { ...state, prescriptionChart: null, requestState, error, status };

    case type.GET_PRESCRIPTION_CHART_SUCCESS:
      prescriptionChart = action.result;
      return {
        ...state,
        prescriptionChart,
        requestState,
        status,
      };

    case type.GET_PRESCRIPTION_CHART_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_DFMR_CHART_REQUEST:
      return { ...state, dfmrChart: null, requestState, error, status };

    case type.GET_DFMR_CHART_SUCCESS:
      dfmrChart = action.result;
      return {
        ...state,
        dfmrChart,
        requestState,
        status,
      };

    case type.GET_DFMR_CHART_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_EMOTION_DATA_REQUEST:
      return { ...state, emotionData: null, requestState, error, status };

    case type.GET_EMOTION_DATA_SUCCESS:
      emotionData = action.result;
      return {
        ...state,
        emotionData,
        requestState,
        status,
      };

    case type.GET_EMOTION_DATA_FAILURE:
      return { ...state, error, requestState, status };

    case type.GET_CONDITION_REQUEST:
      return { ...state, complaintsWithCondition: [], requestState, status };

    case type.GET_CONDITION_SUCCESS:
      complaintCondition = action.result;
      return {
        ...state,
        complaintsWithCondition: complaintCondition,
        requestState,
        status,
      };

    case type.GET_CONDITION_FAILURE:
      return { ...state, error, requestState, status };

    case type.CREATE_CONDITION_REQUEST:
      return { ...state, conditionCreated: {}, requestState, status };

    case type.CREATE_CONDITION_SUCCESS:
      return {
        ...state,
        conditionCreated: action.result,
        requestState,
        status,
      };

    case type.CREATE_CONDITION_FAILURE:
      return { ...state, error, requestState, status };

    case type.RESET_CONDITION_CREATION_STATE:
      return {
        ...state,
        conditionCreated: {},
      };

    case type.GET_CONDITION_TIMELINE_REQUEST:
      return { ...state, conditionTimeline: null, requestState, status };

    case type.GET_CONDITION_TIMELINE_SUCCESS:
      timeline = action.result;
      return {
        ...state,
        conditionTimeline: timeline,
        requestState,
        status,
      };

    case type.GET_CONDITION_TIMELINE_FAILURE:
      return { ...state, error, requestState, status };

    default:
      return state;
  }
};
